export default __webpack_public_path__ + "static/media/picture-placeholder.39ac219c.svg";